export default __webpack_public_path__ + "static/media/signup-thumb.1943c694.png";